export default __webpack_public_path__ + "static/media/chevron-expand.c52fa4fe.svg";